import { jsx as o } from "react/jsx-runtime";
import { useSideNav as e } from "./useSideNav2.mjs";
import { AddCircleOutlineRounded as i } from "@mui/icons-material";
import { FabButton as n } from "./styles94.mjs";
const s = (r) => {
  const { isExpanded: t } = e();
  return /* @__PURE__ */ o(
    n,
    {
      size: "large",
      variant: "secondary",
      color: "primary",
      startIcon: /* @__PURE__ */ o(i, {}),
      $isExpanded: t,
      ...r,
      children: r.children
    }
  );
};
export {
  s as SideNavFabButton
};
//# sourceMappingURL=index130.mjs.map
